import React from "react";
import Button from "../../../components/ui/Button/Button";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../components/ui/InputDate/InputDate";

const Filter = (props) => {
  const { isFirstTab, isThirdTab, options } = props;
  return (
    <div className="bg-input-grey -mt-2 mb-4 p-4">
      <div className="flex justify-between">
        <div className="flex items-center gap-4">
          <h1 className="w-16 font-bold">주문구분</h1>
          <div className="flex items-center">
            <input type="radio" className="mr-1 accent-black" name="orderClass" />
            <span>전체</span>
          </div>
          {isThirdTab ? null : (
            <>
              <div className="flex items-center">
                <input type="radio" className="mr-1 accent-black" name="orderClass" />
                <span>불량접수</span>
              </div>
              <div className="flex items-center">
                <input type="radio" className="mr-1 accent-black" name="orderClass" />
                <span>불량접수 확인</span>
              </div>
            </>
          )}

          {(isFirstTab || isThirdTab) && (
            <>
              <div className="flex items-center">
                <input type="radio" className="mr-1 accent-black" name="orderClass" />
                <span>배송중</span>
              </div>
              <div className="flex items-center">
                <input type="radio" className="mr-1 accent-black" name="orderClass" />
                <span>배송완료</span>
              </div>
            </>
          )}
        </div>
        <div className="flex">
          <Button
            paddingButton="p-1"
            width="w-[7rem]"
            borderColor="border-secondary-grey border"
            text={`필터 검색`}
          />
          <Button
            paddingButton="p-1"
            width="w-[7rem]"
            borderColor="border-secondary-grey border"
            text={`필터 초기화`}
          />
        </div>
      </div>
      <div className="flex mt-2 items-center">
        <h1 className="w-20 font-bold">검색</h1>
        <Dropdown
          placeholder="상품명"
          width="w-36"
          positionDropdown={`top-10`}
          textColor="text-black"
          options={options}
          backgroundDropdown={`bg-white`}
        />

        <input
          type="text"
          className="h-8 ml-2 w-60 border border-primary-grey rounded-[4px] px-2"
          placeholder="필터 선택 후, 검색"
        />
        <div className="flex ml-10 items-center">
          <h1 className="font-bold mr-6">기간</h1>
          <InputDate />
          <span className="mx-2 text-secondary-grey">-</span>
          <InputDate />
        </div>
      </div>
    </div>
  );
};

export default Filter;
